<div class="profile-wrapper">
  <button class="profile-button" (click)="toggleMenu()">
    <img src="images/profile.svg" alt="Profile Icon" class="profile-icon" />
  </button>

  @if (showMenu()) {
    <div class="dropdown-menu">
      <button
        class="menu-item"
        [class.active]="activeLang() === 'de'"
        (click)="selectLanguage('de')"
      >
        Deutsch
      </button>
      <button
        class="menu-item"
        [class.active]="activeLang() === 'en'"
        (click)="selectLanguage('en')"
      >
        English
      </button>
    </div>
  }
</div>
